export const SLIDER_REQUEST = 'SLIDER_REQUEST'
export const SLIDER_SUCCESS = 'SLIDER_SUCCESS'
export const SLIDER_FAILURE = 'SLIDER_FAILURE'


export const MOBILE_SLIDER_REQUEST = 'MOBILE_SLIDER_REQUEST'
export const MOBILE_SLIDER_SUCCESS = 'MOBILE_SLIDER_SUCCESS'
export const MOBILE_SLIDER_FAILURE = 'MOBILE_SLIDER_FAILURE'